import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import {
    PreviewShell as SharedPreviewShell,
    type PreviewAction,
    type PreviewLabels,
} from '@nordinsight/implant-core/ui';
import { EVENT_KEYS, trackClick } from '../../services/api/trackingService';

type PreviewSource = 'implant' | 'cpt' | 'policy';

type Props = Omit<
    ComponentProps<typeof SharedPreviewShell>,
    'labels' | 'onAction'
> & {
    previewSource?: PreviewSource;
};

/** ni-client adapter: keeps translations and analytics out of implant-core. */
export function PreviewShell({ previewSource, ...props }: Props) {
    const { t } = useTranslation();
    const labels: PreviewLabels = {
        printPreview: t('preview.shell.printPreview'),
        copyOverview: t('preview.shell.copyOverview'),
        print: t('preview.shell.print'),
        copy: t('preview.shell.copy'),
        copied: t('preview.shell.copied'),
        close: t('preview.shell.close'),
        noContent: t('preview.shell.noContent'),
        printed: (date) => t('preview.printed', { date }),
    };

    function trackPreviewAction(action: PreviewAction) {
        trackClick(
            action === 'print' ? EVENT_KEYS.clickPrint : EVENT_KEYS.clickCopy,
            { previewSource }
        );
    }

    return (
        <SharedPreviewShell
            {...props}
            labels={labels}
            onAction={trackPreviewAction}
        />
    );
}
